import {useEffect} from 'react';
import {withRouter} from 'react-router';

const ScrollToTop = (props) => {
    const {pathname} = props.location;
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

export default withRouter(ScrollToTop);
